type TImmagine = {
    imgSource: string;
}
const Immagine = ({ imgSource }:TImmagine) => {
  return (
    <img src={imgSource} style={{height:"100vh", width:"100vw", objectFit:"fill"}}/>
  );
};

export default Immagine;